export function store(obj: any, key: string) {
    localStorage.setItem(key, JSON.stringify(obj));
}
export function load(key: string) {
    let res = localStorage.getItem(key);
    if (res)
        return JSON.parse(res);
    return null;
}
